/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core'
import { get } from 'lodash'

const CustomTableHead = ({
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  headCells,
  checkTable,
}) => {
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {checkTable && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'table' }}
            />
          </TableCell>
        )}
        {headCells.map(
          headCell =>
            !get(headCell, 'hide') && (
              <TableCell
                key={get(headCell, 'id')}
                align="center"
                sortDirection={orderBy === get(headCell, 'id') ? order : false}
              >
                {get(headCell, 'ordering') ? (
                  <TableSortLabel
                    active={orderBy === get(headCell, 'id')}
                    direction={orderBy === get(headCell, 'id') ? order : 'asc'}
                    onClick={createSortHandler(get(headCell, 'id'))}
                  >
                    {get(headCell, 'label')}
                  </TableSortLabel>
                ) : (
                  get(headCell, 'label')
                )}
              </TableCell>
            )
        )}
      </TableRow>
    </TableHead>
  )
}

CustomTableHead.propTypes = {
  headCells: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
}

CustomTableHead.defaultProps = {
  headCells: [],
  numSelected: 0,
  onRequestSort: () => {},
  onSelectAllClick: () => {},
  order: 'asc',
  orderBy: '',
  rowCount: 0,
}

export default CustomTableHead
